import React, { useEffect, useState } from "react";
import { withNamespaces } from 'react-i18next';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox'
import i18next from 'i18next';
import * as cookie from '../../scripts/CookiesAppGo';
import { makeStyles } from '@material-ui/core/styles';
import { withCookies, Cookies } from 'react-cookie';

const useStyles = makeStyles((theme) => ({
    divCheckBox: {
        marginTop: '7px',
    },
    label: {
        '& span': {
            fontSize: '0.875rem'
        }
    }
}));


const NotDisplayPWA = (props) => {
    const [displayPWA, setDisplayPWA] = useState(null);
    const { cookies } = props;

    useEffect(() => {
        if (displayPWA != null) {
            cookies.set(cookie.pwa_never_display, displayPWA, { path: '/' });
        }
    }, [displayPWA])

    const handleChange = () => {
        setDisplayPWA(!displayPWA);
    }

    const classes = useStyles();

    return (
        <div className={classes.divCheckBox}>
            <FormControlLabel
                className={classes.label}
                control={
                    <Checkbox
                        checked={displayPWA || false}
                        onChange={handleChange}
                        name="checkedDisplay"
                        variant="success"
                        style={{ color: '#ffffff' }}
                    />
                }
                label={i18next.t('installPwa:never-display')}
            />
        </div>
    );
}

export default withNamespaces(['installPwa'], { wait: true })(withCookies(NotDisplayPWA));